
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-involved",
      function () {
        return require("private-next-pages/get-involved.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-involved"])
      });
    }
  